/**
 * Mirror of server/utils/contactFieldRegistry.js (kept in sync manually).
 * Used by the field-mapping UI so we can render the target field options
 * even before the preview endpoint replies.
 */
export const DEFAULT_CONTACT_FIELDS = [
  { key: "phone", label: "Phone", required: true },
  { key: "country_code", label: "Country Code" },
  { key: "full_name", label: "Full Name" },
  { key: "first_name", label: "First Name" },
  { key: "last_name", label: "Last Name" },
  { key: "email", label: "Email" },
  { key: "company_name", label: "Company Name" },
  { key: "designation", label: "Designation" },
  { key: "city", label: "City" },
  { key: "state", label: "State" },
  { key: "country", label: "Country" },
  { key: "address", label: "Address" },
  { key: "pincode", label: "Pincode" },
  { key: "gender", label: "Gender" },
  { key: "date_of_birth", label: "Date of Birth" },
  { key: "tags", label: "Tags" },
  { key: "status", label: "Status" },
];

export const SKIP_TARGET = "__skip__";
